import refreshIcon from "../resourse/icons/refresh.svg";
import {nextStep} from "../functions/viewPage/NextStep";
import {useNavigate} from "react-router-dom";
import {ServerApi} from '../api/ServerApi';
import React, {useState} from 'react';

//Стили
import './style/palette.css';
import './style/common.css';
import './style/view.css';

//Страница №2
//Страница с этапами процесса подписания. Перенаправление на страницу авторизацию ГосУслуг.
export default function ViewPage() {
    const title = "Страница 2. Страница с этапами процесса подписания. Перенаправление на страницу авторизацию ГосУслуг.";
    const docSessionCode = localStorage.getItem("doc_session_code");
    const appLogicType = localStorage.getItem('app_logic_type');
    const operator_name = localStorage.getItem('operator_name');
    const appDebag = localStorage.getItem("app_debag");

    const decodedOpertorName = operator_name?.replace(/&quot;/g, '"');
    const serverApi = new ServerApi();

    const [esiaUrl, setEsiaUrl] = useState(false);
    const navigate = useNavigate();

    return (
        <div id={'view-page'}>
            <div id={'view-block'}>
                <div className={'view-img-block'}>
                    <img src={'../icons/logo-idgos.png'} alt={'!#'} className={'logo-idgos'}/>
                </div>
                <div className={'view-text-block'}>
                    {Number(appLogicType) === 2 ? (
                        <>
                            <h1 className={'view-title px-4 pt-4 pb-2 text-center m-0 size16_project color_night_blue'}>
                                Уважаемый Абонент.
                            </h1>
                            <p className={'view-subtitle text-center size14_project color_steel_grey mb-4'}>
                                Для актуализации своих персональных данных согласно Федерального закона от
                                07.07.2003 N 126-ФЗ (ред. от 20.02.2026) "О связи" (с изм. и доп., вступ. в силу с 01.07.2026)
                                необходимо пройти процедуру идентификации через портал Единой системы идентификации и
                                аутентификации. Для продолжения  нажмите  кнопку продолжить и вы будете перенаправлены на портал ЕСИА.
                            </p>
                        </>
                    ) : (
                        <>
                            <p className={'view-subtitle text-center size14_project mb-0 color_steel_grey'}>
                                Уважаемый Абонент, Вы находитесь в Сервисе для заключения договора на Услуги связи с
                                Компанией {decodedOpertorName}
                            </p>
                            <h1 className={'view-title p-4 text-center m-0 size16_project color_night_blue'}>
                                Подписание договора на услуги будет в три этапа, на раз два три
                            </h1>
                        </>
                    )}
                </div>
                {Number(appLogicType) !== 2 && (
                    <div className={'view-step-block d-flex align-items-center justify-content-center'}>
                        <div className={'step1 background_pastel_grey py-2 px-1'}>
                            <h1 className={'view-title text-center m-0 size16_project color_night_blue'}>1</h1>
                            <p className={'view-subtitle1 text-center color_steel_grey mb-0 size12_project'}>Авторизация (Госуслуги)</p>
                        </div>
                        <div className={'py-2 px-1 background_pastel_grey mx-1'}> {/*step2*/}
                            <h1 className={'view-title text-center m-0 size16_project color_night_blue'}>2</h1>
                            <p className={'view-subtitle1 text-center color_steel_grey mb-0 size12_project'}>Ознакомление с договором</p>
                        </div>
                        <div className={'step3 py-2 px-1 background_pastel_grey'}>
                            <h1 className={'view-title text-center m-0 size16_project color_night_blue'}>3</h1>
                            <p className={'view-subtitle1 text-center color_steel_grey mb-0 size12_project'}>Подписание через СМС</p>
                        </div>
                    </div>
                )}
                <div className={'view-text-block'}>
                    <p className={'view-subtitle text-center size14_project mx-2 mb-0 color_steel_grey'}>
                        Нажимая продолжить Вы даёте согласие на обработку Персональных данных {decodedOpertorName}, а
                        также его коммерческому представителю ООО «Синтегра»
                    </p>
                </div>
                <div className={'fixed-bottom mx-auto d-flex justify-content-center width90'}>
                    <button className={'view-btn margin40_bottom w-100 cursor weight600_project size14_project border-0 color_white background_bondi'}
                            onClick={() => nextStep(serverApi, title, setEsiaUrl, docSessionCode, navigate, appDebag, appLogicType)} disabled={esiaUrl}>
                        <div className={esiaUrl ? '' : 'd-none'} id={'loader-cont'}>
                            <img className={"objRotate mr-5 loading"} id={'balance-loading'} src={refreshIcon} alt={'refreshIcon'} width={"15px"}/>
                            <h6 id={'redirect-title'}>
                                Перенаправление на Госуслуги
                            </h6>
                        </div>
                        <div id={'nextStep'} className={esiaUrl ? 'd-none' : ''}>
                            Продолжить
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};
